import { Modal } from 'antd';
import styled from 'styled-components';

export const NXIntegrationWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  .nx-integration_header {
    margin-bottom: 24px;

    h1 {
      font-weight: var(--font-bold);
      line-height: 46px;
      margin: 0;
    }
  }

  .nx-integration_tab-content {
    margin-top: 8px;
  }

  /* ── Tab 1: 固定資産台帳 ─────────────────────────────────── */

  .nx-integration_import-info {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 16px;
    max-width: 560px;
  }

  .nx-integration_info-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;

    &:last-of-type {
      border-bottom: none;
    }
  }

  .nx-integration_info-label {
    font-size: var(--font-size-sm);
    font-weight: var(--font-medium);
    color: var(--color-text-secondary, #6b7280);
    min-width: 100px;
  }

  .nx-integration_info-value {
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
  }

  .nx-integration_info-value--complete {
    font-size: var(--font-size-base);
    color: #16a34a;
    font-weight: var(--font-medium);
  }

  .nx-integration_info-value--error {
    font-size: var(--font-size-base);
    color: #dc2626;
    font-weight: var(--font-medium);
  }

  .nx-integration_auto-import-note {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    line-height: 1.7;
    padding: 12px 16px;
    background: #f9fafb;
    border-radius: 8px;
    border: 1px solid var(--color-border-primary, #e5e7eb);
    max-width: 680px;
  }

  /* ── Tab 2: 除却出力 ─────────────────────────────────────── */

  .nx-integration_export-panel {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 400px;
  }

  .nx-integration_form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-size: var(--font-size-sm);
      font-weight: var(--font-medium);
      color: var(--color-text-secondary, #6b7280);
    }
  }

  .nx-integration_sub-note {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    margin-top: 4px;
  }

  .nx-integration_export-btn-row {
    display: flex;
    justify-content: flex-start;

    .ant-btn {
      height: 40px;
      min-width: 120px;
      font-weight: var(--font-bold);
      border-radius: 8px;
    }
  }
`;

export const ExportConfirmDialogWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
    margin-top: 0;
    border-top: 1px solid var(--color-border-primary, #e5e7eb);

    .ant-btn {
      min-width: 120px;
      height: 44px;
      font-weight: var(--font-bold);
      border-radius: 8px;
      margin-inline-start: 0 !important;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .export-confirm_message {
    margin-bottom: 16px;
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
  }

  .ant-table-wrapper {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    overflow: hidden;
  }
`;
